/**
 * Employee Incident Bulk Rejection Service
 * HTTP operations for the bulk rejection of pending marking incidents
 * (ASIS-5250 / REXASIS-008)
 */
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_BulkRejectIncidentsIn, LC_BulkRejectIncidentsOut } from '../types';

/**
 * Service for rejecting multiple marking incidents in a single operation.
 */
export class EmployeeIncidentBulkRejectService {
  /**
   * Reject multiple marking incidents in one call (ASIS-5250). Sends the incident IDs
   * as CSV plus the mandatory approver comment; the approver identity is resolved on
   * the backend (JWT). Always returns HTTP 200 with a per-incident outcome
   * discriminator ('rejected' | 'alreadyResolved') and aggregated totals.
   * PUT /v1/attendances/incidents/bulk-rejection
   */
  bulkReject(
    input: LC_BulkRejectIncidentsIn,
  ): Promise<ApiResponse<LC_BulkRejectIncidentsOut>> {
    return apiClient.put<LC_BulkRejectIncidentsOut>(
      API_CONFIG.ENDPOINTS.EMPLOYEE_INCIDENTS.BULK_REJECT_MANAGEMENT(),
      input,
    );
  }
}

export const employeeIncidentBulkRejectService = new EmployeeIncidentBulkRejectService();
